import { Row, Col, Typography } from "antd";
import "./feedback.css";
import LazyFeedbackForm from "../feedback-form/lazy-feedback-form";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const Feedback = ({ text }) => {
  const isMobileLayout = useMediaQuery(1200);

  return (
    <Row className="feedback content" id="feedback" align="middle">
      <Col span={isMobileLayout ? 24 : 9} className="feedback__text">
        <Typography.Text>{text}</Typography.Text>
      </Col>
      {!isMobileLayout && (
        <Col span={4} className="feedback__spacer" aria-hidden="true" />
      )}
      <Col span={isMobileLayout ? 24 : 11} className="feedback__form-column">
        <LazyFeedbackForm defer />
      </Col>
    </Row>
  );
};

export default Feedback;
